import {
    _showClearIcon,
    _dropSingleCommonHtml,
    _dropCommonHtml
} from "./Common_Fun";

import InitGridObj from "../../../dx/dxInitUtils/initGridObj";
import {GoingUtils,AssertUtils} from "goingutils";
import EditorTypeUtils from "../../../common/editorTypeUtils";

let _initGridObjAndLoadData = function (
    _inputId,
    targetObj,
    vueObj
) {
    let nodeText = $(`#${_inputId}`).val();
    let nodeId = $(
        `#` + _inputId.split("_")[0] + "_" + $(`#${_inputId}`).attr("gridRelId")
    ).val();

    let {x, y} = GoingUtils.getElementPosition($(`#${_inputId}`).get(0));
    //设置显示的下拉位置
    $(`#${_inputId}_grid_drop`)
        .show()
        .css("left", x)
        .css(
            "top",
            y +
            2 +
            parseFloat(
                $(`#${_inputId}`)
                    .closest(".input-group")
                    .css("height")
            )
        );

    let initFlag = $(`#${_inputId}_grid_drop`).attr("initFlag");
    //第一次点击初始化数据 第一次以后只是显示即可
    if (initFlag !== "true") {
        targetObj[_inputId] = GridDrop.initGridObject(
            _inputId,
            vueObj,
            nodeText,
            nodeId
        );
    }
};

let GridDrop = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return _dropSingleCommonHtml(
            item,
            targetObj,
            "go-ctl-grid",
            "far fa-file-alt"
        );
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(
            item,
            targetObj,
            "go-ctl-grid",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    getRealValue(value) {
        return value || " ";
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        //如果不为空的情况下才返回查询的值
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty($("#" + inputElId).val())) {
            backJson[item["id"]] = $("#" + inputElId).val();
        }

        if (AssertUtils.isNotNull(item["gridRelId"])) {
            //设置关联字段的id
            let gridRelId = `${targetObj.prefixCls}_${item["gridRelId"]}`;
            if (AssertUtils.isNotEmpty($("#" + gridRelId).val())) {
                backJson[item["gridRelId"]] = $("#" + gridRelId).val();
            }
        }
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果编数据下拉
        backJson[item["id"]] = $("#" + inputElId).val();
        //如果树存在关联字段
        if (AssertUtils.isNotNull(item["gridRelId"])) {
            backJson[item["gridRelId"]] = $(
                `#${targetObj.prefixCls}_${item["gridRelId"]}`
            ).val();
        }
    },
    getDropContainerHtml(inputId, inputWidth = 250, containerHeight = 300) {
        if (inputWidth < 250) {
            inputWidth = 250;
        }
        let zIndex=GoingUtils.getCurMaxZIndex();

        let html = `<div  id="${inputId}_grid_drop"  class="go-common-drop" style="visibility:hidden;z-index:${zIndex};max-height: ${containerHeight}px; overflow: hidden; width: ${inputWidth}px;"> 
                                <div id="${inputId}_grid" style="width: 100%;height:  ${parseFloat(containerHeight + "") - 10}px;"></div>
                            </div> `;
        return html;
    },
    _loadData() {
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    initGridObject(inputId, vueObj) {
        //获取当前定义的字段属性
        let itemObj = (EditorTypeUtils.itemTemp)[inputId];
        let gridObj = InitGridObj(inputId + "_grid", itemObj["gridConfig"], vueObj);

        //如果点击的不是控件本身 则隐藏
        $(document).click(function (e) {
            let target = $(e.target);
            if (
                !target.is(".go-setting-grid *") &&
                !target.is(".go-setting-grid") &&
                !target.is("#" + inputId + "_inputDiv .go-content *") &&
                !target.is("#" + inputId+"_inputDiv .go-content") &&
                !target.is("#" + inputId + "_grid_drop *") &&
                !target.is("#" + inputId + "_grid_drop")
            ) {
                $(`#${inputId}_grid_drop`).hide();
            }
        });

        return gridObj;
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        function _initCtlDefEvent(inputId) {
            //点击输入框 弹出下拉选择数据
            $(`#${inputId}`).click(function () {
                let _inputId = $(this).attr("id");
                $(`#${inputId}_grid_drop`)
                    .show()
                    .css("visibility", "visible");
                _initGridObjAndLoadData(_inputId, targetObj, vueObj);
            });

            //点击下拉图标 弹出下拉选择
            $(`#${inputId}_down`).click(function () {

                let _inputId = $(this)
                    .attr("id")
                    .split("_down")[0];
                $(`#${inputId}_grid_drop`)
                    .show()
                    .css("visibility", "visible");
                _initGridObjAndLoadData(_inputId, targetObj, vueObj);
            });
        }

        //初始化树控件
        $(parentObj)
            .find(".go-ctl-grid")
            .each(function () {
                //如果声明了
                let ctl = $(this).attr("ctl");
                if (ctl === "auto") {
                    let inputId = $(this).attr("id");
                    //获取下拉的容器html代码
                    let html = GridDrop.getDropContainerHtml(inputId, inputWidth);
                    $(html).appendTo($("#main_router_view"));
                    _initCtlDefEvent(inputId + "");
                }
            });
    }
};
export default GridDrop;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-grid-drop.js